/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// $( document ).ready(function() {
//     $('.qtybox .btnqty').on('click', function(){
//   var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
//   if($(this).hasClass('qtyplus')) {
//     qty++;
//   }else {
//     if(qty > 1) {
//       qty--;
//     }
//   }
//   qty = (isNaN(qty))?1:qty;
//   $(this).parent('.qtybox').find('.quantity-input').val(qty);
// }); 
// });

// var elem = document.querySelector('.pi-bg-sldr');
// var flkty1 = new FlickityFade( elem1, {
//   // options
//   cellAlign: 'left',
//   contain: true
// });

/* Loop through all dropdown buttons to toggle between hiding and showing its dropdown content - This allows the user to have multiple dropdowns without any conflict */
var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function() {
  this.classList.toggle("active");
  var dropdownContent = this.nextElementSibling;
  if (dropdownContent.style.display === "block") {
  dropdownContent.style.display = "none";
  } else {
  dropdownContent.style.display = "block";
  }
  });
}

